<template>
    <v-expand-transition>
        <div class="inb-entry-buttons">
            <div>
                <v-tooltip left>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            depressed
                            small
                            v-bind="attrs"
                            v-on="on"
                            color="primary"
                            class="inb-entry-button"
                            @click="onEditMessage"
                        >
                            <v-icon small color="white">fas fa-pen</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ $t("inb.edit.menu.edit") }}</span>
                </v-tooltip>
            </div>

            <div>
                <v-tooltip left v-if="!message.incidentId && message.incidentType && message.sites.length > 0">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            depressed
                            small
                            v-bind="attrs"
                            v-on="on"
                            color="primary"
                            class="inb-entry-button"
                            @click="onCreateIncident"
                        >
                            <v-icon small color="white">fas fa-plus</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ $t("inb.edit.menu.create") }}</span>
                </v-tooltip>

                <v-tooltip left v-if="message.incidentId !== null">
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            depressed
                            small
                            v-bind="attrs"
                            v-on="on"
                            color="primary"
                            class="inb-entry-button"
                            @click="onGotoIncident"
                        >
                            <v-icon small color="white">fas fa-arrow-left</v-icon>
                        </v-btn>
                    </template>
                    <span>{{ $t("inb.edit.menu.goto") }}</span>
                </v-tooltip>
            </div>
        </div>

    </v-expand-transition>
</template>

<script>

import Inb  from "@/modules/inb/service/Inb.js";
import Inc  from "@/modules/inc/service/Inc.js";

export default {
    name: "InbMessageEntryMenu",

    props: {
        message: {
            required: true
        },
        value: {
            required: true
        }
    },

    methods: {
        onEditMessage() {
            this.$emit('input', false);
            this.$emit('edit', this.message);
        },

        onCreateIncident() {
            this.$emit('input', false);
            Inb.create(this, this.message.id, this.$t("inb.loading.create")).then((incidentId) => {
                this.message.confirmed = true;
                this.message.incidentId = incidentId;
                Inc.goto(this, incidentId);
            });
        },

        onGotoIncident() {
            this.$emit('input', false);
            Inc.goto(this, this.message.incidentId);
        },

        onConfirm() {
            Inb.confirm(this, this.message.id, true);
        },
    }
}
</script>

<style scoped>

.inb-message-buttons {
    position: absolute;
    width: 20px;
    display: block;
    right: 25px;
    top: 5px;
}

.inb-entry-buttons {
    width: 100%;
    margin-bottom: 10px;
    border-radius: 5px;
    display: flex;
    justify-content: space-between;
}

.inb-entry-button {
    min-width: 25px!important;
    padding-left: 10px!important;
    margin: 0!important;
}


</style>